import React from 'react'

const Card = (props) => {
  return (
    <div className={`p-8 bg-white rounded-3xl shadow-lg mb-5 ${props.className}}`}>{ props.children }</div>
  )
}

export default Card